module.exports = __webpack_public_path__ + "img/ic_16_search_light.ddd61cdc.svg";